module.exports = __webpack_public_path__ + "media/zelda.dd0ac63d.webm";